"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var hocs_1 = require("../../hocs");
var StyledFlexGridItem_1 = require("./StyledFlexGridItem");
var FlexGridItem = function (props) {
    var tag = props.tag, a11yTitle = props.a11yTitle, children = props.children, forwardRef = props.forwardRef, rest = tslib_1.__rest(props, ["tag", "a11yTitle", "children", "forwardRef"]);
    return (React.createElement(StyledFlexGridItem_1.StyledFlexGridItem, tslib_1.__assign({ as: tag || 'div', ref: forwardRef }, rest), children));
};
FlexGridItem.defaultProps = {
    tag: 'div',
    xs: 12
};
var FlexGridItemWrapper = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(FlexGridItem);
exports.FlexGridItem = FlexGridItemWrapper;
//# sourceMappingURL=FlexGridItem.js.map